import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { Router, NavigationEnd  } from '@angular/router';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const RoleMenuAccess: Record<string, string[]> = {
  'Admin' : ['all', '!assignmentDispatch', 'pushNotification', 'token-search', 'reports'], 
  'Super Admin' : ['all', '!assignmentDispatch', 'pushNotification'],
  'Purchase Officer' : ['tokenRequest', 'Vendor Dispatch Approval', 'issueTicket', 'vendorAssignment'],
  'Plant Incharge': ['tokenRequest', 'GRN', 'Token Attachment', 'Activation Request', 'issueTicket'],
  'Vendor': ['issueTicket', 'vendorAssignment', 'assignmentDispatch'],
  'Finance Officer':['finance'],
  'System':['all']
} 

@Component({
  selector: 'app-rs-menu',
  templateUrl: './rs-menu.page.html',
  styleUrls: ['./rs-menu.page.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class RsMenuPage implements OnInit {
  showMenu = false
  highlightMenu = ''
  showSecondaryMenu = false
  highlightSecondaryMenu = ''
  roleName: any = ''
  allowedMenu: string[] = []
  
  private destroyRef = inject(DestroyRef);

  constructor(private router: Router) { }

  ngOnInit() {
    this.loadRoleMenu()
    this.router.events.pipe(filter(event => event instanceof NavigationEnd ), distinctUntilChanged((prev, curr)=> (prev as NavigationEnd).urlAfterRedirects === (curr as NavigationEnd).urlAfterRedirects), takeUntilDestroyed(this.destroyRef))
    .subscribe(()=> {
      this.loadRoleMenu()
      this.getMenuData()
    })
  }

  loadRoleMenu() {
    const role = sessionStorage.getItem('role')
    this.roleName = role ? JSON.parse(role)?.role_name : ''
    this.allowedMenu = RoleMenuAccess[this.roleName] ?? []
  }

  isVisible(menuItem: string): boolean {
    if (this.allowedMenu.includes(`!${menuItem}`)) return false;
    return this.allowedMenu.includes('all') || this.allowedMenu.includes(menuItem)
  }

  isTokenMenuVisible(): boolean {
    return ['tokenRequest', 'vendorAssignment', 'Vendor Dispatch Approval', 'issueTicket', 'GRN', 'Token Attachment', 'Activation Request', 'assignmentDispatch', 'finance'].includes(this.highlightMenu)
  }

  isLoyaltyEngineVisible(): boolean {
    return this.roleName === 'Admin' || this.roleName === 'Super Admin';
  }

  isLoyaltyEngineMenuActive(): boolean {
    return ['loyaltyProgram', 'loyaltyProducts', 'loyaltyBenefits', 'loyaltySchemes', 'loyaltyMembers', 'promotions', 'loyaltyTransactions', 'memberBenefits'].includes(this.highlightMenu);
  }
  // 'locationSettings','bankPayout',','reportAnalytics', 'pickList'
  // isPortalSettingsMenuActive(): boolean {
  //   return ['accessControl', 'category', 'bannerSettings','manageApprovals','portalTokenRequest'].includes(this.highlightMenu)
  // }
isPortalSettingsMenuActive(): boolean {
  return ['accessControl','category','bannerSettings','manageApprovals',
          'portalTokenRequest','locationSettings'].includes(this.highlightMenu);
}

  private getMenuData() {
    let route = this.router.routerState.root.firstChild; 
    while(route?.firstChild) {
      route = route.firstChild; 
    }

    console.log(route?.snapshot.data)

    this.showMenu = route?.snapshot.data['menu']?.showMenu || ''
    this.highlightMenu = route?.snapshot.data['menu']?.highlightMenu || ''

    // Keep the correct notification submenu selected even if the route data
    // uses a different highlight value.
    const currentUrl = this.router.url.split('?')[0];
    if (currentUrl.startsWith('/push-notification')) {
      this.highlightMenu = 'pushNotification';
    } else if (currentUrl.startsWith('/system-notifications')) {
      this.highlightMenu = 'System Notification';
    }

    // Product, Redeemable Product, and Promoted Product all share the same
    // /product-catalog route and are only distinguished by the `tab` query
    // param, so the static route-data highlightMenu can't tell them apart.
    // Resolve the actual sub-tab from the query param here instead.
    if (this.highlightMenu === 'productCatalog') {
      const tab = route?.snapshot.queryParams?.['tab'];
      if (tab === 'redeemable') {
        this.highlightMenu = 'redeemableProduct';
      } else if (tab === 'promoted') {
        this.highlightMenu = 'promotedProduct';
      } else {
        this.highlightMenu = 'productCatalog';
      }
    }
    if (currentUrl.startsWith('/portal-token-request')) {
  this.highlightMenu = 'portalTokenRequest';
} else if (currentUrl.startsWith('/location-settings')) {
  this.highlightMenu = 'locationSettings';
}

    this.showLoyaltyEngineMenu = ['loyaltyProgram', 'loyaltyProducts', 'loyaltyBenefits', 'loyaltySchemes', 'loyaltyMembers', 'promotions', 'loyaltyTransactions', 'memberBenefits'].includes(this.highlightMenu)
    this.showTokensMenu = ['tokenRequest', 'vendorAssignment', 'Vendor Dispatch Approval', 'issueTicket', 'GRN', 'Token Attachment', 'Activation Request', 'assignmentDispatch', 'finance'].includes(this.highlightMenu)
    // this.showPortalSettingsMenu = ['accessControl','category','bannerSettings',  'manageApprovals',  'portalTokenRequest'].includes(this.highlightMenu)
   this.showPortalSettingsMenu =
  ['accessControl','category','bannerSettings','manageApprovals',
   'portalTokenRequest','locationSettings'].includes(this.highlightMenu)
    this.showProductCatalogMenu = ['productCatalog', 'redeemableProduct', 'promotedProduct'].includes(this.highlightMenu)
    this.showPushNotificationMenu = this.isPushNotificationMenuActive()
    // 'bankPayout', 'locationSettings', 'reportAnalytics', 'pickList',
    // this.showSecondaryMenu = route?.snapshot.data['secondaryMenu']?.showMenu || ''
    // this.highlightSecondaryMenu = route?.snapshot.data['secondaryMenu']?.highlightMenu || ''
  }

  showTokensMenu: boolean = false
  toggleTokenDropDown() {
    this.showTokensMenu = !this.showTokensMenu
    if(this.showTokensMenu) {
      if(this.roleName === 'Admin' || this.roleName === 'Purchase Officer' || this.roleName === 'Plant Incharge')
        this.navigateToTokenRequest()
      } else if(this.roleName === 'Vendor') {
        this.navigateToVendorAssignment()
      } else if(this.roleName === 'Finance Officer') {
        this.navigateToFinance()
      }
  }

  showPushNotificationMenu: boolean = false

  isPushNotificationVisible(): boolean {
    return this.roleName === 'Admin' || this.roleName === 'Super Admin'
  }

  togglePushNotificationDropDown() {
    this.showPushNotificationMenu = !this.showPushNotificationMenu;

    if (this.showPushNotificationMenu) {
      this.highlightMenu = 'pushNotification';
      this.router.navigate(['/push-notification']);
    }
  }

  isPushNotificationMenuActive(): boolean {
    return ['pushNotification', 'System Notification'].includes(this.highlightMenu)
  }

  showPortalSettingsMenu: boolean = false
  togglePortalDropDown() {
    this.showPortalSettingsMenu = !this.showPortalSettingsMenu
    if(this.showPortalSettingsMenu) {
     // this.navigateToAccessControl()
     this.navigateToManageApproval()
    }
  }

  showProductCatalogMenu: boolean = false
  toggleProductCatalogDropDown() {
    this.showProductCatalogMenu = !this.showProductCatalogMenu
    if(this.showProductCatalogMenu) {
      this.navigateToProductCatalog()
    }
  }

  isProductCatalogMenuActive(): boolean {
    return ['productCatalog', 'redeemableProduct', 'promotedProduct'].includes(this.highlightMenu)
  }

  showLoyaltyEngineMenu = false
  toggleLoyaltyEngineDropDown() {
    this.showLoyaltyEngineMenu = !this.showLoyaltyEngineMenu
    if (this.showLoyaltyEngineMenu) {
      this.navigateToLoyaltyProgram()
    }
  }


  navigateToHome() {
    this.router.navigate(['/dashboard']);
  }

  navigateToCustomer360() {
    this.router.navigate(['/customer360']);
  }
  navigateToGRN() {
    this.router.navigate(['/grn']);
  }
  navigateToTokenAttachment() {
    this.router.navigate(['/token-attachment']);
  }
  navigateToTokenRequest() {
    this.router.navigate(['/token-request']);
  }
  navigateToVendorDispatchApproval() {
    this.router.navigate(['/vendor-dispatch-approval']);
  }

  navigateToDispatchApproval() {
    this.router.navigate(['/dispatch-approval']);
  }

  navigateToLoyaltyProgram() {
    this.router.navigate(['/loyalty-program']);
  }

  navigateToProducts() {
    this.router.navigate(['/loyalty-products']);
  }

  navigateToBenefits() {
    this.router.navigate(['/loyalty-benefits']);
  }

  navigateToMemberBenefits() {
    this.router.navigate(['/member-benefits']);
  }

  navigateToSchemes() {
    this.router.navigate(['/loyalty-schemes']);
  }

  navigateToMembers() {
    this.router.navigate(['/loyalty-members']);
  }

  navigateToTransactions() {
    this.router.navigate(['/loyalty-transactions']);
  }

  navigateToAccessControl() {
    this.router.navigate(['/access-control']);
  }

  navigateToBannerSettings() {
    this.router.navigate(['banner-settings']);
  }

  navigateToBankPayout() {
    this.router.navigate(['bank-payout']);
  }

  navigateToLocationSettings() {
    this.router.navigate(['location-settings']);
  }

  navigateToManageApproval() {
    this.router.navigate(['manage-approvals']);
  }

  navigateToReportAnalytics() {
    this.router.navigate(['/report-analytics']);
  }

  navigateToPickList() {
    this.router.navigate(['pick-list']);
  }
  navigateToActivationRequest() {
    this.router.navigate(['/activation-request']);
  }

  navigateToVendorAssignment() {
    this.router.navigate(['vendor-assignment']);
  }
  navigateToAssignmentDispatch() {
    this.router.navigate(['assignment-dispatch']);
  }
  navigateToFinance() {
    this.highlightMenu = 'finance';
    this.router.navigate(['/finance']);
  }
  navigateToIssueTicket() {
    this.router.navigate(['issue-ticket']);
  }
  // Add this method to your RsMenuPage class
  navigateToPortalTokenRequest() {
    this.router.navigate(['/portal-token-request']);
  }
  navigateToSurvey() {
    this.router.navigate(['/survey']);
  }
  navigateToEvent() {
    this.router.navigate(['/event']);
  }
  // Add Push Notification navigation method
  navigateToPushNotification() {
    this.showPushNotificationMenu = true;
    this.highlightMenu = 'pushNotification';
    this.router.navigate(['/push-notification']);
  }
  navigateToSystemNotifications() {
    this.showPushNotificationMenu = true;
    this.highlightMenu = 'System Notification';
    this.router.navigate(['/system-notifications']);
  }

  navigateToPromotions() {
    this.router.navigate(['promotions']);
  }

  navigateToProductCatalog() {
    this.router.navigate(['/product-catalog']);
  }

  navigateToRedeemableProduct() {
    this.router.navigate(['/product-catalog'], { queryParams: { tab: 'redeemable' } });
  }

  navigateToPromotedProduct() {
    this.router.navigate(['/product-catalog'], { queryParams: { tab: 'promoted' } });
  }
  navigateToTokenSearch() {
  this.router.navigate(['/rs-token-search']);
}
  navigateToStock() {
    this.router.navigate(['/stock']);
  }
  navigateToReports() {
  this.router.navigate(['/reports']);
}
navigateToCategory() {
  this.router.navigate(['/rs-category']);
}

}